import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { MachinePath } from '../../Common';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { MachineFailureCategory } from '@/services/repository/machines';
import { Failure, LoadFailure, SaveFailure } from './Model';
import { goBack } from '@/common/reactnav';
import { BackButton } from '@/components/layout/NavBar';
import { GalleryProvider, SimpleGallery } from '@/components/forms/common/gallery/gallery';
import { gallery } from '@/components/forms/machines/Failures';
import { Stream } from '@/services/common/stream';
import * as osfiles from "../../../../../components/forms/common/gallery/osfiles"

const API_BASE = "/api/public/tmp/gallery"

export const AddFailureGallery = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const machineId = useParams().machineid
  const [translates, setTranslates] = useState<Translates>()
  const [machine, setMachine] = useState<Machine>()
  const [failure, setFailure] = useState<Failure>()
  // const [categories, setCategories] = useState<MachineFailureCategory[]>(services.machines.listFailureCategories())
  const statusStreamRef = useRef<Stream<osfiles.UploadStatus>>(new Stream<osfiles.UploadStatus>())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  useEffect(() => {
    if (machineId === undefined) {
      return
    }
    setFailure(LoadFailure(machineId))
  }, [machineId])

  if (translates === undefined || machine === undefined || translates === undefined || failure === undefined || machineId === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='add-failure' services={services} translates={translates} session={session} path={MachinePath({ session, translates, machine })}
    navbarLeft={<BackButton services={services} translates={translates} fallbackUrl={`/communal/machine/${machineId}/failures/add/page2`} />}>

    <h2 className='page-title'>{translates.for(`failures.gallery.title`)}</h2>

    <GalleryProvider insertUrl={`${API_BASE}/new`} updateUrl={`${API_BASE}/{id}/upload`} fetchUrl={`${API_BASE}/{id}/list`} removeUrl={`${API_BASE}/{id}/remove/{fid}`} token={session?.token} translates={translates} galleryId={failure.galleryId} statusStream={statusStreamRef.current}
      onChange={(id: string) => setFailure((prev) => {
        if (!prev) return prev;
        const updated = { ...prev, galleryId: id }
        SaveFailure(machineId, updated)
        return updated
      })}>
      <SimpleGallery />
    </GalleryProvider>

    <div className='approve-btn' onClick={() => {
      SaveFailure(machineId, failure)
      goBack(navigate, `/communal/machine/${machineId}/failures/add/page2`)
    }}>
      {translates.for(`failures.gallery.approve`)}
    </div>

  </MainPageLayout>
}
